const g = async ({ network: l, platformsApiUrl: s }) => {
  try {
    const r = await fetch(`${s}/${l}`);
    if (r != null && r.ok) {
      const a = await r.json();
      let o = /* @__PURE__ */ new Map();
      for (let e = 0; e < a.length; e++)
        o.set(a[e].category, a[e].viewing_platforms.map((t, n) => ({
          id: `${a[e].category.slug}-${n}`,
          image_url: t != null && t.override_image ? t.image_override : t.platform.image,
          alt_text: t.platform.name,
          link: t.link_url,
          target: (t == null ? void 0 : t.target) ?? "_blank"
        })));
      return o;
    } else
      return console.log(`An error was returned from fetch. HTTP Response Code: ', ${r == null ? void 0 : r.status}`), {
        error: {
          type: "Fetch Response Error",
          statusCode: r == null ? void 0 : r.status
        }
      };
  } catch (r) {
    return console.log("Fetch failed with error:", r), {
      error: {
        type: "Fetch Failed",
        message: r
      }
    };
  }
};
export {
  g as getViewingPlatforms
};
